// @ngInject
function bootstrapModal($provide) {
    $provide.decorator('$uibModalStack',bootstrapModalDelegate);
}

// @ngInject
function bootstrapModalDelegate($delegate,loadSpinnerService) {

    var openFn = $delegate.open;


    $delegate.open = function() {
        var args = Array.prototype.slice.call(arguments);

        var spinnerName = "modalSpinner" + Math.random();

        args[1].content = '<div load-spinner spinner-name="' + spinnerName + '"></div>' + args[1].content;

        args[0].startLoadingSpinner = function() {
            loadSpinnerService.start(spinnerName);
        };
        args[0].stopLoadingSpinner = function() {
            loadSpinnerService.stop(spinnerName);
        };

        openFn.apply(null,args);
    };

    return $delegate;
}

angular
    .module('decorators.bootstrapModal', [])
    .config(bootstrapModal);
